import { render } from "./MPassword.vue?vue&type=template&id=2b0aa508&scoped=true&ts=true"
import script from "./MPassword.vue?vue&type=script&lang=ts"
export * from "./MPassword.vue?vue&type=script&lang=ts"

import "./MPassword.vue?vue&type=style&index=0&id=2b0aa508&scoped=true&lang=css"

import exportComponent from "/var/www/mmwapp/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b0aa508"]])

export default __exports__